import type { ButtonHTMLAttributes } from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "../../lib/cn";

// Schaltfläche im shadcn/ui-Stil (Entscheidung 36): Der Code gehört dem Projekt,
// Varianten beschreibt `cva` (class-variance-authority) als Tabelle von Klassen.
// Gestaltung nach CI: Hauptaktion in Nacht, Nebenaktion weiß mit Rahmen.
const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 rounded-md font-medium whitespace-nowrap transition-colors disabled:pointer-events-none disabled:opacity-50",
  {
    variants: {
      variant: {
        primary: "bg-nacht text-papier hover:bg-tiefsee",
        secondary: "border border-line bg-card text-ink hover:bg-page",
        ghost: "text-ink hover:bg-page",
        link: "text-link-fg underline-offset-4 hover:underline",
        // Anmelden bei Google/Microsoft: Farben nach Anbieter-Vorgabe (styles.css)
        idp: "border border-idp-line bg-idp text-idp-ink hover:bg-idp-hover",
      },
      size: {
        md: "h-10 px-4 text-sm",
        lg: "h-12 px-5 text-base",
      },
    },
    defaultVariants: { variant: "primary", size: "md" },
  },
);

// Props = alle normalen <button>-Attribute + unsere Varianten.
// VariantProps<typeof buttonVariants> leitet die erlaubten Werte aus cva ab.
export type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> &
  VariantProps<typeof buttonVariants>;

export function Button({ className, variant, size, type = "button", ...props }: ButtonProps) {
  return (
    <button type={type} className={cn(buttonVariants({ variant, size }), className)} {...props} />
  );
}
